import ScriptProvider from '@website/components/utilities/ScriptProvider';
import config from '@website/config';
import { DateTime } from 'luxon';
import { Table } from 'react-bootstrap';
import { SpaceWithOwner } from './GroupBookingsList';

const googleScriptUrl = `https://maps.googleapis.com/maps/api/js?key=${config.Google.placesApiKey}&libraries=places`;

function HostDashboardGuestMeetPointsTableRow({
  space,
}: {
  space: SpaceWithOwner;
}) {
  const guestName = space.guest.givenName
    ? `${space.guest.givenName} ${space.guest.familyName}`
    : undefined;
  const ownerName = `${space.owner.givenName} ${space.owner.familyName}`;

  // Arrive
  const arriveAt = DateTime.fromISO(
    space.guest.tripForm?.meetPoint?.arriveAt?.localTime,
  ).toFormat('HH:mm');

  // Depart
  const departAt = DateTime.fromISO(
    space.guest.tripForm?.departPoint?.arriveAt?.localTime,
  ).toFormat('HH:mm');

  // Meet address
  const meetAddressLines = [
    space.guest.tripForm?.meetPoint?.address?.addressLine1,
    space.guest.tripForm?.meetPoint?.address.locality,
    space.guest.tripForm?.meetPoint?.address?.dependentLocality,
  ];
  const meetAddress = meetAddressLines.filter((i) => i && i !== '').join(', ');

  // Depart address
  const departAddressLines = [
    space.guest.tripForm?.departPoint?.address?.addressLine1,
    space.guest.tripForm?.departPoint?.address.locality,
    space.guest.tripForm?.departPoint?.address?.dependentLocality,
  ];
  const departAddress = departAddressLines
    .filter((i) => i && i !== '')
    .join(', ');

  return (
    <tr>
      <td>{guestName || <i>Booked by {ownerName}</i>}</td>
      {space.guest.tripForm?.meetPoint ? (
        <>
          <td colSpan={5}>{meetAddress}</td>
          <td colSpan={2}>{arriveAt}</td>
        </>
      ) : (
        <td colSpan={7}>
          <span className="text-muted">Not provided</span>
        </td>
      )}

      {space.guest.tripForm?.departPoint ? (
        <>
          <td colSpan={5}>{departAddress}</td>
          <td colSpan={2}>{departAt}</td>
        </>
      ) : (
        <td colSpan={7}>
          <span className="text-muted">Not provided</span>
        </td>
      )}
    </tr>
  );
}

type Props = {
  spaces: SpaceWithOwner[];
};

export default function HostDashboardGuestMeetPointsTable({ spaces }: Props) {
  return (
    <ScriptProvider url={googleScriptUrl}>
      <Table striped bordered responsive>
        <thead>
          <tr>
            <th rowSpan={2}>Name</th>
            <th colSpan={5}>Meet Point</th>
            <th colSpan={2}>Time</th>
            <th colSpan={5}>Depart Point</th>
            <th colSpan={2}>Time</th>
          </tr>
        </thead>
        <tbody>
          {spaces.map((space) => (
            <HostDashboardGuestMeetPointsTableRow
              space={space}
              key={space.id}
            />
          ))}
        </tbody>
      </Table>
    </ScriptProvider>
  );
}
